import SignatureIcon from './SignatureIcon';

export default SignatureIcon;
